// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"2d50b85f","72":"d5955a02","322":"fd857c25","918":"1a34fc27"}[chunkId] + ".chunk.js";
};